import script from "./messages.vue?vue&type=script&lang=js"
export * from "./messages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/en/messages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2141464c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2141464c', __exports__)) {
    api.reload('2141464c', __exports__)
  }
  
}


export default __exports__